import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { SERVICES } from "@/data/turboData";

const Services = () => (
  <div className="pt-16 md:pt-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.2em] text-[var(--tt-accent)] font-semibold">
          Services
        </div>
        <h1 className="font-display text-5xl md:text-6xl font-bold text-[var(--tt-navy)] mt-4 leading-[0.98]">
          Pick the right way to ship.
        </h1>
        <p className="mt-5 text-lg text-[var(--tt-ink-soft)] leading-relaxed">
          Seven purpose-built services for individuals and businesses. Fast air,
          consolidated bulk, ocean freight (FCL &amp; LCL), rail freight, economy
          international, suitcase shipping, or business freight — one team, one
          bill, worldwide.
        </p>
      </div>

      <div className="mt-14 grid lg:grid-cols-2 gap-6">
        {SERVICES.map((s) => (
          <article key={s.slug} className="card p-8 flex flex-col">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <h2 className="font-display text-3xl font-bold text-[var(--tt-navy)]">
                    {s.name}
                  </h2>
                  {s.badge && (
                    <span className="text-[10px] uppercase tracking-[0.16em] font-semibold rounded-full px-2.5 py-1 bg-[var(--tt-accent)] text-white">
                      {s.badge}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-[var(--tt-muted)]">{s.eta}</span>
                  <span className="font-semibold text-[var(--tt-accent)]">{s.startsAt}</span>
                </div>
              </div>
            </div>

            <p className="mt-5 text-[var(--tt-ink-soft)] leading-relaxed">
              {s.long}
            </p>

            <ul className="mt-5 grid sm:grid-cols-2 gap-2.5">
              {s.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm text-[var(--tt-ink)]">
                  <CheckCircle2 className="h-4 w-4 text-[var(--tt-accent)] mt-0.5 shrink-0" /> {b}
                </li>
              ))}
            </ul>

            <div className="mt-7 pt-6 border-t border-[var(--tt-line)] flex items-center gap-3 flex-wrap">
              {(s.slug === "ocean-freight" || s.slug === "rail-freight") ? (
                <>
                  <Link to="/freight/quote" data-testid={`freight-quote-${s.slug}`} className="btn-primary !py-2.5 !px-5 text-sm">
                    Get a freight quote <ArrowUpRight className="h-4 w-4" />
                  </Link>
                  <Link to="/freight/china-to-europe" className="text-sm font-semibold text-[var(--tt-navy)] hover:text-[var(--tt-accent)] transition">
                    China ↔ Europe
                  </Link>
                  <Link to="/freight/china-to-africa" className="text-sm font-semibold text-[var(--tt-navy)] hover:text-[var(--tt-accent)] transition">
                    China → Africa
                  </Link>
                  <Link to="/freight/usa-to-zambia" className="text-sm font-semibold text-[var(--tt-navy)] hover:text-[var(--tt-accent)] transition">
                    USA → Zambia
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/quote" className="btn-primary !py-2.5 !px-5 text-sm">
                    Get a quote <ArrowUpRight className="h-4 w-4" />
                  </Link>
                  <Link to="/contact" className="text-sm font-semibold text-[var(--tt-navy)] hover:text-[var(--tt-accent)] transition">
                    Talk to sales
                  </Link>
                </>
              )}
            </div>
          </article>
        ))}
      </div>

      {/* Comparison hint */}
      <div className="mt-16 rounded-3xl bg-[var(--tt-navy)] text-white p-8 md:p-12 grid md:grid-cols-[1fr_auto] gap-6 items-center">
        <div>
          <h3 className="font-display text-3xl font-bold leading-tight">Not sure which one fits?</h3>
          <p className="mt-2 text-white/75 max-w-xl">
            Our team will recommend the right service based on what you&apos;re
            shipping, where it&apos;s going, and how fast you need it.
          </p>
        </div>
        <Link to="/contact" className="btn-primary self-start md:self-center">
          Talk to an expert <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </div>
);

export default Services;
